import { render, staticRenderFns } from "./ReverseArrows.vue?vue&type=template&id=00f030e3&scoped=true&"
import script from "./ReverseArrows.vue?vue&type=script&lang=ts&"
export * from "./ReverseArrows.vue?vue&type=script&lang=ts&"
import style0 from "./ReverseArrows.vue?vue&type=style&index=0&id=00f030e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f030e3",
  null
  
)

export default component.exports